/** Whether a stereotype-scoped custom attribute should appear in the form. */
export const isCustomAttributeVisibleForStereotypes = (
	stereotypesForType: number[] | undefined,
	stereotypeId?: number,
	batchStereotypeIds?: number[],
): boolean => {
	if (stereotypesForType === undefined || stereotypesForType.length === 0) {
		return true
	}

	if (stereotypeId === undefined) {
		if (!batchStereotypeIds?.length) {
			return false
		}

		return batchStereotypeIds.every((id) => stereotypesForType.includes(id))
	}

	return stereotypesForType.includes(stereotypeId)
}

export const getAttributeStereotypesForStructureType = (
	attributeStereotypeIds: number[] | undefined,
	structureTypeStereotypeIds: number[],
): number[] | undefined =>
	attributeStereotypeIds?.filter((id) => {
		if (structureTypeStereotypeIds.length === 0) {
			return true
		}

		return structureTypeStereotypeIds.includes(id)
	})
